module.exports = __webpack_public_path__ + "img/标题文字_关于枢源.2c5af922.svg";